import{useState as t,useEffect as r}from"react";var e=function(e,n){void 0===n&&(n=1e3);var o=t(""),u=o[0],i=o[1];return r(function(){var t=setTimeout(function(){i(e)},n);return function(){clearTimeout(t)}},[e,n]),u};export{e as default};
//# sourceMappingURL=index.js.map
